import React, {useState} from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import AjoutEtablissement from "./functions/Ajout_Etablissement";
import Documentation from "./functions/Documentation";
import Page_Principale from "./functions/Page_Principale";
import ValidationModification from "./functions/ValidationModifcation";
import SQLEditor from "./functions/SQLEditor";
import { AuthProvider } from "./AuthContext";
import './css/App.css'


function App() {
  return (
      <AuthProvider>  
          <Router>
              <Routes>
                  <Route path="/" element={<Page_Principale />} />
                  <Route path="/ajout_etablissement" element={<AjoutEtablissement />} />
                  <Route path="/documentation" element={<Documentation />} />
                  <Route path="/validation_modification" element={<ValidationModification />} />
                  <Route path="/SQL" element={<SQLEditor />} />
              </Routes>
          </Router>
      </AuthProvider>
  );
}



export default App;
